import styled from 'styled-components';

const LabelWrapper = styled.div<{ $isChanged?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  padding: 5px 16px;
  gap: 8px;
  background-color: ${(props) => (
    props.$isChanged ? props.theme.colors.main_cta_light : props.theme.colors.widget_background
  )};
  color: ${(props) => (
    props.$isChanged ? props.theme.colors.main_cta : props.theme.colors.text
  )};
  border-radius: 100px;
  cursor: pointer;
  border: ${(props) => (props.$isChanged ? `1px solid ${props.theme.colors.main_cta}` : '1px solid transparent')};
  
  &:hover {
    color: ${(props) => props.theme.colors.main_cta};
    background-color: ${(props) => props.theme.colors.main_cta_light};
    transition: all .2s ease-in;
  }
  
  &:hover .arrow-down {
    margin-top: 8px;
    transition: all .2s ease-in;
  }
  
  i {
    color: ${(props) => (props.$isChanged ? props.theme.colors.main_cta : props.theme.colors.inactive)}
  }
  
  p {
    font-size: 13px;
    max-width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 20px;
  }
`;

const SearchList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: max-content;
  min-width: 100%;
  background: ${(props) => props.theme.colors.widget_background};
  box-shadow: ${(props) => props.theme.shadows.dropdown};
  border-radius: 12px;
  max-height: 400px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.inactive};
    border-radius: 20px;
    border: 3px solid ${(props) => props.theme.colors.inactive};
  }
`;

const SearchItemWrapper = styled.li`
  padding: 16px;
  font-size: 13px;
  cursor: pointer;
  
  &:first-of-type {
    border-radius: 12px 12px 0 0;
  }
  
  &:last-of-type {
    border-radius: 0 0 12px 12px;
  }
  
  &:hover {
    background: ${(props) => props.theme.colors.widget_hover_background};
  }
  
  input[type="checkbox"],
  input[type="radio"]{
    display:none;
  }
  
  .checkbox {
    display:inline-block;
    width: 16px;
    height: 16px;
    margin: 0 8px -4px 0; 
    position: relative;
    
    &:before {
      transition: all .3s ease-in-out;
      content: "";
      position: absolute;
      z-index: 1;
      width: 16px;
      height: 16px;
      background: transparent;
      border: 1px solid ${(props) => props.theme.colors.inactive};
    }
    
    &:after {
      transition: all .3s ease-in-out;
      content: "";
      position: absolute;
      width: 16px;
      height: 16px;
      background: transparent;
      z-index: 0;
      border: none;
    }
  }

  input[type="checkbox"] + label .checkbox {
    &:before,
    &:after {
      border-radius: 4px;
    }
  }

  input[type="radio"] + label .checkbox {
    &:before,
    &:after {
      border-radius: 50%;
    }
  }

  input[type="checkbox"]:checked + label .checkbox,
  input[type="radio"]:checked + label .checkbox{
    &:after {
      width: 16px;
      height: 16px;
      background: ${(props) => props.theme.colors.main_cta};
      transition: all .2s ease-in;
    }
  }

  input[type="checkbox"]:checked + label .checkbox,
  input[type="radio"]:checked + label .checkbox{
    &:before {
      left: 5px;
      top: 2px; 
      width: 6px;
      height: 11px;
      border: solid ${(props) => props.theme.colors.inactive};
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
`;

export default {
  LabelWrapper, SearchItemWrapper, SearchList,
};
